import { render, staticRenderFns } from "./FeatureList.vue?vue&type=template&id=550c01d4&scoped=true&"
import script from "./FeatureList.vue?vue&type=script&lang=ts&"
export * from "./FeatureList.vue?vue&type=script&lang=ts&"
import style0 from "./FeatureList.vue?vue&type=style&index=0&id=550c01d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550c01d4",
  null
  
)

export default component.exports